module.exports = __webpack_public_path__ + "img/atlanta_content_img_04.a151f741.jpg";